import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function WhatsAppFab() {
  const [phone, setPhone] = useState("");
  useEffect(() => {
    api.get("/config").then((r) => setPhone(r.data.whatsapp_owner || "")).catch(() => {});
  }, []);
  const href = phone
    ? `https://wa.me/${phone.replace("+", "")}?text=${encodeURIComponent("Hi Million Pixels, I'd like to know more / place an order.")}`
    : "#";
  return (
    <a href={href} target="_blank" rel="noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#25D366] text-white pl-3 pr-4 py-3 rounded-full shadow-lg hover:scale-105 transition-transform"
      data-testid="whatsapp-fab">
      <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 018.413 3.488 11.82 11.82 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.82 9.82 0 001.519 5.256l-.999 3.648 3.47-.903z"/></svg>
      <span className="text-sm font-semibold font-accent hidden sm:block">Chat / Order</span>
    </a>
  );
}
